import valueMapping from '@Apis/valueMapping.api';
import {
	CreateValuemappingProfileRequest,
	GetValuemappingProfilesParams,
	ValuemappingProfileCheckOverridesRequest,
	ValuemappingProfileCheckSensorDeletionsRequest,
} from '@Types/valuemappingManager.types';

export const getValueMappingProfiles = (
	params: GetValuemappingProfilesParams,
) => valueMapping.get('/profile', { params: params });

export const getValueMappingProfile = (profileId: string) =>
	valueMapping.get(`/profile/${profileId}`);

export const checkValuemappingProfileOverrides = (
	params: ValuemappingProfileCheckOverridesRequest,
) => valueMapping.post('/profile/overrides/check', params);

export const createValuemappingProfile = (
	params: CreateValuemappingProfileRequest,
) => valueMapping.post('/profile', params);

export const updateValuemappingProfile = (
	profileId: string,
	params: CreateValuemappingProfileRequest,
) => valueMapping.put(`/profile/${profileId}`, params);

export const deleteValuemappingProfile = (profileId: string) =>
	valueMapping.delete(`/profile/${profileId}`);

export const checkValuemappingProfileSensorDeletions = (
	profileId: string,
	params: ValuemappingProfileCheckSensorDeletionsRequest,
) => valueMapping.post(`/profile/${profileId}/deletions/check`, params);
